var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('b',{attrs:{"id":"icon-back"}},[_c('i',{staticClass:"fas fa-arrow-left text-green"})])
}]

export { render, staticRenderFns }